(() => {
  const pendingClass = 'klaviyo-hidden-until-hero-passed';
  const root = document.documentElement;

  if (!root.classList.contains(pendingClass)) return;

  const updateVisibility = () => {
    const hero = document.querySelector('#main-content > .shopify-section:first-of-type');

    // Do not leave forms hidden if the homepage hero cannot be identified.
    if (!hero) {
      root.classList.remove(pendingClass);
      return;
    }

    root.classList.toggle(pendingClass, hero.getBoundingClientRect().bottom > 0);
  };

  updateVisibility();
  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });
})();
